import classNames from 'classnames'
import { JSX, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { webApp } from '@shared'

import { Button } from '../Button'
import styles from './MainButton.module.scss'

interface MainButtonProps {
  disabled?: boolean
  hidden?: boolean
  progress?: boolean
  color?: string
  textColor?: string
  onClick?(): void
  text?: string
  stepASide?: boolean
}

const mainButton = webApp ? webApp.MainButton : null

export const MainButton = ({
  disabled,
  color,
  textColor,
  text,
  onClick,
  progress,
  hidden,
  stepASide,
}: MainButtonProps): JSX.Element | null => {
  const { t } = useTranslation()

  const resetButton = () => {
    if (mainButton) {
      const { button_color, button_text_color } = webApp?.themeParams

      if (disabled) {
        mainButton.disable()
      } else {
        mainButton.enable()
      }

      mainButton.hideProgress()
      mainButton.setParams({
        color: button_color,
        text_color: button_text_color,
      })
    }
  }

  useEffect(() => {
    resetButton()
  }, [])

  useEffect(() => {
    if (hidden) {
      if (mainButton) {
        mainButton.hide()
        resetButton()
      }
    } else {
      if (mainButton) {
        resetButton()
        mainButton.show()
      }
    }
  }, [hidden])

  useEffect(() => {
    if (!mainButton) {
      return
    }

    if (typeof progress === 'boolean') {
      if (progress) {
        mainButton.showProgress()
        mainButton.disable()
      } else {
        mainButton.hideProgress()
      }
    }

    if (typeof disabled === 'boolean') {
      if (disabled || progress) {
        mainButton.disable()
      } else {
        mainButton.enable()
      }
    }
  }, [disabled, progress])

  useEffect(() => {
    if (!mainButton) {
      return
    }

    if (color || textColor) {
      mainButton.setParams({ color, text_color: textColor })
    }

    if (!color) {
      const { button_color } = webApp.themeParams

      mainButton.setParams({
        color: button_color,
      })
    }

    if (!textColor) {
      const { button_text_color } = webApp.themeParams

      mainButton.setParams({
        text_color: button_text_color,
      })
    }
  }, [color, textColor])

  useEffect(() => {
    if (!mainButton) {
      return
    }

    if (text) {
      mainButton.setText(text)
      // !mainButton.isVisible && mainButton.show()
    } else if (mainButton.isVisible) {
      // mainButton.hide()
    }
  }, [text])

  useEffect(() => {
    if (mainButton && onClick) {
      mainButton.onClick(onClick)

      return () => {
        if (mainButton) {
          mainButton.offClick(onClick)
        }
      }
    }
  }, [onClick])

  if (webApp?.platform === 'unknown' && text && !hidden) {
    return (
      <div
        className={classNames(
          styles.mainButtonWrap,
          stepASide && styles.stepASide
        )}
      >
        <Button type="primary" onClick={onClick} disabled={disabled}>
          {progress ? t('ds.mainButton.loading') : text}
        </Button>
      </div>
    )
  }

  return null
}
